import * as types from './actionTypes'

export const appendSnackbarAction = snackbar => ({
  type: types.APPEND_SNACKBAR,
  payload: snackbar,
})

// * merge snackbar by color key ("red", "green", etc.)
export const setSnackbarAction = snackbar => ({
  type: types.SET_SNACKBAR,
  payload: snackbar,
})

export const setSnackbarErrorAction = message => ({
  type: types.SET_SNACKBAR,
  payload: {
    content: message,
    color: 'red',
  },
})

export const removeSnackbarAction = snackbarIndex => ({
  type: types.REMOVE_SNACKBAR,
  payload: snackbarIndex,
})
